<ngx-ui-loader></ngx-ui-loader>
<div fxFill >
  <main-header></main-header>
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <footer></footer>

</div>
